import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-exponent-list" as const;

export const OpenExponentListEventDataSchema = z.object({
  structureIds: z.array(z.string()),
  structureId: z.string(),
  eventId: z.string(),
});

export type OpenExponentListEventData = z.infer<
  typeof OpenExponentListEventDataSchema
>;

export type OpenExponentListEvent = AppEvent<
  typeof eventName,
  OpenExponentListEventData
>;

export const isOpenExponentListEvent = (
  event: AnyAppEvent
): event is OpenExponentListEvent => event.name === eventName;

export { eventName as openExponentList };
